import { useEffect, useRef } from 'react';
// This sets window.MathQuill
import MathQuill from 'legacy-lib/mathquill-patch';

export function useMathQuillStatic() {
  const ref = useRef();

  useEffect(() => {
    let staticMath = null;
    if (ref.current) {
      // Grab equation before it gets mutated away
      const equationText = ref.current.innerText;
      try {
        // This mutates the DOM element into MathQuill
        staticMath = MathQuill.StaticMath(ref.current);
      } catch (error) {
        throw new Error(`Invalid Mathquill equation "${equationText}"`);
      }
    }
    return () => {
      if (staticMath) {
        staticMath.revert().html();
      }
    };
  }, [ref]);

  return [ref];
}
